import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PS } from '../theme';
import { Icon } from '../lib/icons';

const IMG = {
  gold: 'https://static.prod-images.emergentagent.com/jobs/bdbaf734-d9a6-4e03-a21d-b0c0cde96e44/images/80e63f0f3cf957233fec547f62e7975256e7a027f61b30c647890b28c0ac5c80.png',
  iphone: 'https://static.prod-images.emergentagent.com/jobs/bdbaf734-d9a6-4e03-a21d-b0c0cde96e44/images/b55d6242972462d94e22e862408c9d8b75bb3d1bb79c1a510460675660249f8b.png',
  scooter: 'https://static.prod-images.emergentagent.com/jobs/bdbaf734-d9a6-4e03-a21d-b0c0cde96e44/images/ee3d9391596231ae41f09540a02f92f8374a2bfb28909b22c90d5e7868af124c.png',
  bag: 'https://static.prod-images.emergentagent.com/jobs/bdbaf734-d9a6-4e03-a21d-b0c0cde96e44/images/25f5ade3c4087868a50f844481647f8e86e29153f7ad398796b0cd22d5d078cd.png',
};

const PRODUCTS = [
  { id: 'gold', circleId: 'circle_prod_gold', img: IMG.gold, name: 'ทองคำแท้ 96.5% · 1 บาท', per: 3200, rounds: 12, cap: 12 },
  { id: 'iphone', circleId: 'circle_prod_iphone', img: IMG.iphone, name: 'iPhone รุ่นล่าสุด', per: 2800, rounds: 10, cap: 10 },
  { id: 'scooter', circleId: 'circle_prod_scooter', img: IMG.scooter, name: 'มอเตอร์ไซค์ สกู๊ตเตอร์', per: 2500, rounds: 20, cap: 20 },
  { id: 'bag', circleId: 'circle_prod_bag', img: IMG.bag, name: 'กระเป๋าแบรนด์เนม', per: 4000, rounds: 10, cap: 10 },
];

const baht = (n) => `฿${n.toLocaleString('en-US')}`;

const TrustChip = ({ icon: Ico, children }) => (
  <div style={{ display: 'inline-flex', gap: 5, alignItems: 'center', padding: '4px 9px', borderRadius: 999, background: 'rgba(32,28,24,0.05)', fontSize: 11, fontWeight: 600, color: PS.textMuted }}>
    <Ico size={12} stroke={PS.forest} /> {children}
  </div>
);

function ProductCard({ p, onClick }) {
  return (
    <div data-testid={`product-share-card-${p.id}`} onClick={onClick} className="ps-press ps-fade-up"
      style={{ background: PS.surface2, border: `1px solid ${PS.line}`, borderRadius: 16, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <div style={{ position: 'relative', width: '100%', aspectRatio: '1 / 1', background: PS.panel }}>
        <img src={p.img} alt={p.name} loading="lazy"
          style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
        <div style={{ position: 'absolute', top: 8, left: 8, padding: '3px 8px', borderRadius: 999, background: 'rgba(26,26,26,0.82)', color: '#f5f1ea', fontSize: 10, fontWeight: 600, display: 'inline-flex', gap: 4, alignItems: 'center' }}>
          <Icon.coin size={11} stroke="#f5f1ea" /> จับฉลากยุติธรรม
        </div>
      </div>
      <div style={{ padding: 13, display: 'flex', flexDirection: 'column', gap: 8, flex: 1 }}>
        <div style={{ fontSize: 13.5, fontWeight: 600, letterSpacing: -0.2, lineHeight: 1.3 }}>{p.name}</div>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 5 }}>
          <span className="num" style={{ fontSize: 18, fontWeight: 500, color: PS.terracotta }}>{baht(p.per)}</span>
          <span style={{ fontSize: 11, color: PS.textMuted }}>/ เดือน · {p.rounds} งวด</span>
        </div>
        <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: 10, fontWeight: 700, color: '#fff', padding: '3px 8px', borderRadius: 999, background: 'oklch(0.64 0.16 48)', letterSpacing: 0.3 }}>
            ตัวอย่าง · DEMO
          </span>
          <span style={{ fontSize: 12, fontWeight: 600, color: PS.ink, display: 'inline-flex', gap: 3, alignItems: 'center' }}>
            ดูวงตัวอย่าง <Icon.chevronR size={13} stroke={PS.ink} />
          </span>
        </div>
      </div>
    </div>
  );
}

/** Aspirational "แชร์ซื้อของ" use-case showcase. Used on Landing + Home.
 *  `onExplore(productId)` fires when a card is tapped. `wide` = page padding for landing. */
export default function ProductShareShowcase({ onExplore, wide = false }) {
  const nav = useNavigate();
  const go = (p) => (onExplore ? onExplore(p) : nav(`/app/circle/${p.circleId}`));
  const pad = wide ? '0 24px' : '0 20px';
  return (
    <section data-testid="product-share-showcase" style={{ padding: wide ? '8px 0 12px' : '4px 0 8px' }}>
      <div style={{ padding: pad, marginBottom: 14 }}>
        <div style={{ fontSize: wide ? 11 : 10, color: PS.textMuted, letterSpacing: 1, textTransform: 'uppercase', marginBottom: 6 }}>แชร์ซื้อของ · Group-buy</div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', flexWrap: 'wrap', gap: 8 }}>
          <h2 style={{ margin: 0, fontSize: wide ? 'clamp(22px,3vw,30px)' : 18, fontWeight: 700, letterSpacing: -0.4 }}>
            ตั้งวงเพื่อ<span style={{ color: PS.terracotta }}>ได้ของที่อยากได้</span>
          </h2>
        </div>
        <p style={{ margin: '8px 0 0', fontSize: wide ? 14 : 12.5, color: PS.textMuted, lineHeight: 1.6, maxWidth: 560 }}>
          ลงเงินกันเป็นงวด แล้วจับฉลากว่าใครได้ของก่อน — สุ่มด้วยระบบที่ตรวจสอบย้อนหลังได้ ทุกการจ่ายมีหลักฐานครบ ไม่ต้องกลัวโกง
        </p>
        <div style={{ display: 'flex', gap: 8, marginTop: 12, flexWrap: 'wrap' }}>
          <TrustChip icon={Icon.coin}>สุ่มยุติธรรม ตรวจสอบได้</TrustChip>
          <TrustChip icon={Icon.shield}>มีหลักฐานทุกงวด</TrustChip>
          <TrustChip icon={Icon.lock}>ถูกต้องตามกฎหมาย</TrustChip>
        </div>
      </div>
      <div style={{ padding: pad }}>
        <div className="ps-prod-grid">
          {PRODUCTS.map((p) => (
            <ProductCard key={p.id} p={p} onClick={() => go(p)} />
          ))}
        </div>
      </div>
    </section>
  );
}
